// Shared language constants and the initial-language resolution rule.
//
// Deliberately dependency-free: src/i18n.js imports this module, so anything it
// imported back would risk a circular dependency at boot.
//
// There is ONE stored language value, used for the UI and for reports/Excel alike.
// A stored explicit choice always wins; on first visit (nothing stored yet) the
// browser's language is used if it's one we support, else English.

export const APP_LANGUAGE_STORAGE_KEY = 'app-language'

export const SUPPORTED_LANGUAGES = ['en', 'de', 'it']

export const FALLBACK_LANGUAGE = 'en'

// {value,label} options for the language picker (LanguageSwitcher.vue).
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'it', label: 'Italiano' }
]

const readStored = (key) => {
  try {
    const value = localStorage.getItem(key)
    return value && SUPPORTED_LANGUAGES.includes(value) ? value : null
  } catch {
    // localStorage throws in private-mode / sandboxed contexts. Treat as unset.
    return null
  }
}

const browserLanguage = () => {
  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language]
  for (const candidate of candidates) {
    if (!candidate) continue
    const code = candidate.split('-')[0].toLowerCase()
    if (SUPPORTED_LANGUAGES.includes(code)) return code
  }
  return null
}

// Precedence: explicit choice (persisted) > browser (first visit only) > 'en'.
//
// A stored choice ALWAYS wins - changing the browser or OS language must never
// silently override a deliberate selection, or the same account renders in
// different languages on different machines.
export const resolveInitialAppLanguage = () =>
  readStored(APP_LANGUAGE_STORAGE_KEY) ?? browserLanguage() ?? FALLBACK_LANGUAGE
